import DwhExportLib, { DwhExportMeta } from '@wg/dwh-export-lib';
import log from 'loglevel';

type Meta = {
    [key: string]: string | number | boolean | null | undefined,
};

class DwhExport {
    static readonly PROJECT: string = 'dockyard';

    static readonly INTERVAL: number = 3;

    static readonly MAX_EVENT_BATCH_SIZE: number = 5;

    private readonly url: string | null = null;

    private readonly accountId: number | null = null;

    private readonly DwhExportLib: DwhExportLib;

    constructor() {
        this.url = window.dockyard.urls.dwhExport;
        this.accountId = Number(window.dockyard.state.account?.spaId);
        this.DwhExportLib = new DwhExportLib({
            url: this.url,
            exportInterval: DwhExport.INTERVAL,
            maxEventsBatchSize: DwhExport.MAX_EVENT_BATCH_SIZE,
            project: DwhExport.PROJECT,
        });
        this.DwhExportLib.start();
    }

    send = (event: string, meta: Meta = {}, force = false) => {
        if (!this.url) {
            return;
        }

        if (!this.accountId) {
            return;
        }

        try {
            this.DwhExportLib.push(event, <DwhExportMeta>meta);

            if (force) {
                this.DwhExportLib.send();
            }
        } catch (e) {
            log.error('Stats export failed', e);
        }
    };
}

export default new DwhExport();
